class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const timeZone = this.dataset.timezone || 'America/New_York';
    this.targetTime = CountdownTimer.zonedTimeToUtc(this.dataset.targetDate, timeZone);
    this.hideOnComplete = this.dataset.hideOnComplete === 'true';

    this.daysEl = this.querySelector('[data-countdown-days]');
    this.hoursEl = this.querySelector('[data-countdown-hours]');
    this.minutesEl = this.querySelector('[data-countdown-minutes]');
    this.secondsEl = this.querySelector('[data-countdown-seconds]');
    this.unitsEl = this.querySelector('.countdown-timer__units');
    this.labelEl = this.querySelector('.countdown-timer__label');
    this.messageEl = this.querySelector('.countdown-timer__complete-message');

    if (isNaN(this.targetTime)) {
      return;
    }

    this.tick();
    this.interval = setInterval(this.tick.bind(this), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const distance = this.targetTime - Date.now();

    if (distance <= 0) {
      clearInterval(this.interval);
      this.onComplete();
      return;
    }

    const days = Math.floor(distance / 86400000);
    const hours = Math.floor((distance % 86400000) / 3600000);
    const minutes = Math.floor((distance % 3600000) / 60000);
    const seconds = Math.floor((distance % 60000) / 1000);

    this.setValue(this.daysEl, days);
    this.setValue(this.hoursEl, hours);
    this.setValue(this.minutesEl, minutes);
    this.setValue(this.secondsEl, seconds);
  }

  setValue(el, value) {
    if (!el) return;
    el.textContent = String(value).padStart(2, '0');
  }

  onComplete() {
    if (this.hideOnComplete) {
      this.hidden = true;
      return;
    }

    if (this.unitsEl) this.unitsEl.hidden = true;
    if (this.labelEl) this.labelEl.hidden = true;
    if (this.messageEl) this.messageEl.hidden = false;
  }

  // Converts a wall-clock "YYYY-MM-DDTHH:MM" string, meant as local time in
  // `timeZone`, into the correct UTC epoch millis — regardless of the
  // visitor's own device timezone. Automatically accounts for DST (e.g.
  // EST vs EDT) because Intl resolves the real offset for that exact date.
  static zonedTimeToUtc(dateTimeString, timeZone) {
    const match = String(dateTimeString).match(
      /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})(?::(\d{2}))?/
    );
    if (!match) return NaN;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);
    const hour = Number(match[4]);
    const minute = Number(match[5]);
    const second = match[6] ? Number(match[6]) : 0;
    const utcGuess = Date.UTC(year, month - 1, day, hour, minute, second);

    const dtf = new Intl.DateTimeFormat('en-US', {
      timeZone,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    const parts = dtf.formatToParts(new Date(utcGuess)).reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});

    const asIfUtc = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour === '24' ? '0' : parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );

    const offset = asIfUtc - utcGuess;
    return utcGuess - offset;
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
